import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  notePresenceActivity,
  setPresenceContext,
  startPresence,
} from 'services/presence';
import { logoutAllTabs } from 'services/logoutSync';

function IdleWarning({ deadline }: { deadline: number }) {
  const remaining = () =>
    Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
  const [seconds, setSeconds] = useState(remaining);
  useEffect(() => {
    const update = () =>
      setSeconds(Math.max(0, Math.ceil((deadline - Date.now()) / 1000)));
    update();
    const timer = setInterval(update, 1000);
    return () => clearInterval(timer);
  }, [deadline]);
  return (
    <Modal
      open
      title="Are you still there?"
      centered
      closable={false}
      mask={{ closable: false }}
      keyboard={false}
      footer={
        <Button
          type="primary"
          onClick={event => notePresenceActivity(event.nativeEvent)}
        >
          Keep me logged in
        </Button>
      }
    >
      <p>
        You’ll be logged out in <strong>{seconds} seconds</strong> due to
        inactivity.
      </p>
      <p>Choose “Keep me logged in” to continue.</p>
    </Modal>
  );
}

export default function PresenceObserver() {
  const { pathname } = useLocation();
  const auth = useSelector((state: any) => state.auth.item);
  const [warning, setWarning] = useState<number>();
  const sessionId =
    Number(pathname.match(/\/sessions?\/(\d+)/)?.[1]) || undefined;
  useEffect(() => {
    setPresenceContext({ session_id: sessionId });
  }, [sessionId]);
  useEffect(() => {
    if (!auth.userId) return;
    return startPresence(logoutAllTabs, setWarning);
  }, [auth.userId, auth.token]);
  return auth.userId && warning ? <IdleWarning deadline={warning} /> : null;
}
